module.exports = __webpack_public_path__ + "img/2.4597c382.jpg";